import { all, takeEvery, put, fork } from "redux-saga/effects";

import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions/index";
import * as API from "../api";

export function* cancelOrder() {
  yield takeEvery(actionTypes.MALL_CANCEL_ORDER, function*(action) {
    yield put(actions.enableLoading());
    try {
      const response = yield API.mallCancelOrder(action.id, action.data);
      if (response.data.success) {
        yield put(actions.mallCancelOrderSuccess());

        // Reload Order
        let params = { order_id: action.id };
        yield put(actions.mallLoadOrderDetail(params));
      } else {
        alert("Warning: Fail to cancel order. \n" + response.data.message);
        yield put(actions.mallCancelOrderFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error, "Fail to cancel order. \n"));
      yield put(actions.mallCancelOrderFail());
      yield put(actions.disableLoading());
    }
  });
}
export function* withdrawCancellation() {
  yield takeEvery(actionTypes.MALL_WITHDRAW_CANCELLATION, function*(action) {
    try {
      const response = yield API.mallWithdrawCancellation(action.id);
      if (response.data.success) {
        yield put(actions.mallWithdrawCancellationSuccess());

        // Reload Order
        let params = { order_id: action.orderID };
        yield put(actions.mallLoadOrderDetail(params));
      } else {
        alert(
          "Warning: Fail to withdraw cancellation. \n" + response.data.message
        );
        yield put(actions.mallWithdrawCancellationFail());
      }
    } catch (error) {
      yield put(
        actions.handleAPIError(error, "Fail to withdraw cancellation. \n")
      );
      yield put(actions.mallWithdrawCancellationFail());
    }
  });
}

export default function* mallCancellationSaga() {
  yield all([fork(cancelOrder), fork(withdrawCancellation)]);
}
